[
  {
    "code": "CM-AD",
    "name": "Adamaoua"
  },
  {
    "code": "CM-CE",
    "name": "Centre"
  },
  {
    "code": "CM-ES",
    "name": "East"
  },
  {
    "code": "CM-EN",
    "name": "Far North"
  },
  {
    "code": "CM-LT",
    "name": "Littoral"
  },
  {
    "code": "CM-NO",
    "name": "North"
  },
  {
    "code": "CM-NW",
    "name": "North-West"
  },
  {
    "code": "CM-SU",
    "name": "South"
  },
  {
    "code": "CM-SW",
    "name": "South-West"
  },
  {
    "code": "CM-OU",
    "name": "West"
  }
]